/**
 * Resolves frontend route path for a permission screen name.
 * Uses Tela resources from DB cache when available; avoids importing router (circular dep).
 */
export function getScreenRoute(screenName, recursosCache = []) {
    if (!screenName) return null;

    const tela = recursosCache.find(
        (r) => r.descricao_tipo_recurso === "Tela" && r.nome === screenName
    );
    if (tela && tela.rota) {
        return { path: tela.rota, screenName };
    }

    const byCod = recursosCache.find(
        (r) =>
            r.descricao_tipo_recurso === "Tela" &&
            r.cod_recurso === screenName.replace(/[^a-zA-Z0-9]/g, "").toUpperCase()
    );
    if (byCod && byCod.rota) {
        return { path: byCod.rota, screenName };
    }

    const path = `/${screenName.charAt(0).toLowerCase()}${screenName.slice(1)}`;
    return { path, screenName };
}

export function getAllScreenNames(manifestScreens) {
    return (manifestScreens || []).slice().sort((a, b) => a.localeCompare(b));
}